import React, { Component } from "react";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { Styles } from "./styles/tabBox.js";

class TabBox extends Component {
  render() {
    return (
      <Styles>
        {/* Tab Box Area */}
        <section className="tab-section">
          <Container>
            <Tab.Container defaultActiveKey="mission">
              <Row>
                <Col lg="3" md="4">
                  <Nav className="flex-column">
                    <Nav.Item>
                      <Nav.Link eventKey="mission">
                        <i className="las la-arrow-right"></i> Our Mission
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="vision">
                        <i className="las la-arrow-right"></i> Our Vision
                      </Nav.Link>
                    </Nav.Item>
                    {/* <Nav.Item>
                      <Nav.Link eventKey="ranking">
                        <i className="las la-arrow-right"></i> Our Ranking
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="research">
                        <i className="las la-arrow-right"></i> Our Research
                      </Nav.Link>
                    </Nav.Item>{" "} */}
                  </Nav>
                </Col>
                <Col lg="9" md="8">
                  <Tab.Content>
                    <Tab.Pane eventKey="mission">
                      <h4 className="tab-title">Our Mission</h4>
                      <p className="tab-desc">
                        Our mission is to guide students through every step of
                        their educational journey — from university selection to
                        successful enrollment in Switzerland — with honesty,
                        precision, and care. We strive to simplify the complex
                        study-abroad process and make Swiss education accessible
                        to every deserving student.
                      </p>
                      <ul className="list-unstyled check-list">
                        <li>
                          <i className="fa fa-check"></i> Providing transparent
                          and personalized counselling to every student.
                        </li>
                        <li>
                          <i className="fa fa-check"></i> Offering end-to-end
                          support — from applications and admissions to visa and
                          pre-departure.
                        </li>
                        <li>
                          <i className="fa fa-check"></i> Partnering with
                          reputed Swiss universities to ensure quality education
                          pathways.
                        </li>
                        <li>
                          <i className="fa fa-check"></i> Empowering students
                          with knowledge, confidence, and global opportunities.
                        </li>
                      </ul>
                    </Tab.Pane>

                    <Tab.Pane eventKey="vision">
                      <h4 className="tab-title">Our Vision</h4>
                      <p className="tab-desc">
                        At Swiss Schools, our vision is to become the most
                        trusted and student-centric platform connecting aspiring
                        learners with Switzerland’s top-ranked universities. We
                        aim to inspire students to pursue education that blends
                        global exposure, academic excellence, and real-world
                        impact.
                      </p>
                      <ul className="list-unstyled check-list">
                        <li>
                          <i className="fa fa-check"></i> Building a strong
                          bridge between Indian students and Swiss institutions.
                        </li>
                        <li>
                          <i className="fa fa-check"></i> Promoting Switzerland
                          as a hub for innovation, quality education, and
                          multicultural learning.
                        </li>
                        <li>
                          <i className="fa fa-check"></i> Developing globally
                          competent graduates who contribute to society with
                          integrity and leadership.
                        </li>
                        <li>
                          <i className="fa fa-check"></i> Creating lifelong
                          success stories through education that transforms
                          futures.
                        </li>
                      </ul>
                    </Tab.Pane>
                    <Tab.Pane eventKey="ranking">
                      <h4 className="tab-title">Our Ranking</h4>
                      <p className="tab-desc">
                        Swiss School has earned a reputation as a top global
                        education consultancy. Our consistent track record of
                        successfully guiding students to prestigious
                        universities worldwide has positioned us among the most
                        trusted and highly recommended consultancy firms.
                      </p>
                      <ul className="list-unstyled check-list">
                        <li>
                          <i className="fa fa-check"></i> Successfully guided
                          95% of our students to top-ranked universities.
                        </li>
                        <li>
                          <i className="fa fa-check"></i> Over 15 years of
                          experience in providing expert education counseling.
                        </li>
                        <li>
                          <i className="fa fa-check"></i> Recognized by global
                          education bodies for excellence in consultancy
                          services.
                        </li>
                      </ul>
                    </Tab.Pane>
                    <Tab.Pane eventKey="research">
                      <h4 className="tab-title">Our Research</h4>
                      <p className="tab-desc">
                        At Swiss School, we continually research global
                        education trends, admission requirements, and
                        scholarship opportunities. Our in-depth analysis ensures
                        that students receive the most accurate, up-to-date
                        guidance for studying abroad and achieving academic
                        success.
                      </p>
                      <ul className="list-unstyled check-list">
                        <li>
                          <i className="fa fa-check"></i> Conduct comprehensive
                          research on international universities and programs.
                        </li>
                        <li>
                          <i className="fa fa-check"></i> Analyze admission
                          patterns to optimize student placement and success.
                        </li>
                        <li>
                          <i className="fa fa-check"></i> Provide data-driven
                          guidance on scholarships and funding opportunities.
                        </li>
                      </ul>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Container>
        </section>
      </Styles>
    );
  }
}

export default TabBox;
